var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.845 3.17.076.066 4.4 4.4a.8.8 0 0 1-.94 1.272l-2.538 2.537-1.14 3.037a.8.8 0 0 1-.125.222l-.056.064-1.2 1.2a.8.8 0 0 1-1.056.065l-.076-.066-2.235-2.234-3.034 3.034a.8.8 0 0 1-1.197-1.056l.066-.075L6.824 12.6 4.59 10.367a.8.8 0 0 1-.066-1.056l.066-.075 1.2-1.2a.8.8 0 0 1 .206-.15l.079-.033 3.036-1.14 2.537-2.536a.8.8 0 0 1 1.197-1.007"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin-icon.0c41e74fb2fcbd815a41307cc5839370.svg";